import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

// modules
import studentModule from "./student";
import authModule from "./auth";
import courseModule from "./course";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state: {
    appName: "Adroit Learners",
    alert: null,
    subscriptions: [],
    PAYSTACK_PUBLIC_KEY: "pk_test_6426d10b7366a4a986249d29d2ed29e1ef8d49fc",
    STORAGE_URL:
      process.env.NODE_ENV == "production"
        ? "https://exams.weybanskytech.com.ng/storage"
        : "http://adroit-learners.local/storage"
  },

  mutations: {
    showAlert(state, alert) {
      state.alert = alert;
      if (state.alert != null && state.alert.status == "error")
        state.alert.status = "danger";
    },

    subscriptions(state, subscriptions) {
      state.subscriptions = subscriptions || [];
    }
  },

  actions: {
    async getSubscriptions({ commit }) {
      /* Get All site subscriptions */
      return axios
        .get("/subscriptions")
        .then(response => {
          commit("subscriptions", response.data.subscriptions);
          return response;
        })
        .catch(error => {
          commit("showAlert", {
            status: "danger",
            message: "Could not get subscriptions."
          });
          throw error;
        });
    },

    async verifyTransaction(context, reference) {
      return axios
        .get("/api/payments/verify?reference=" + reference)
        .then(response => {
          return response;
        })
        .catch(error => {
          throw error;
        });
    }
  },

  getters: {},

  modules: {
    student: studentModule,
    auth: authModule,
    course: courseModule
  }
});
